import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '../pages/layout'
import page1 from 'pages/page1/page1'
import drug from 'pages/page1/drug'
import press from 'pages/page1/press'
import press1 from 'pages/page1/press1'

Vue.use(VueRouter)

const routes = [
  {
    path: '/', //路由默认跳转
    redirect: '/page1',
    component: layout,
    children: [
      {
        path: '/page1',
        name: 'page1',
        component: page1
      }
    ]
  },
  {
    path: '/page1',
    name: 'layout',
    component: layout,
    children: [
      {
        path: '/page1',
        name: 'page1',
        component: page1
      }
    ]
  },
  {
    path: '/drug',
    name: 'layout',
    component: layout,
    children: [
      {
        path: '/drug',
        name: 'drug',
        component: drug
      }
    ]
  },
  {
    path: '/press',
    name: 'layout',
    component: layout,
    children: [
      {
        path: '/press',
        name: 'press',
        component: press
      }
    ]
  },
  {
    path: '/press1',
    name: 'layout',
    component: layout,
    children: [
      {
        path: '/press1',
        name: 'press1',
        component: press1
      }
    ]
  }
];

// 路由导航冗余报错（路由重复）
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js